<template>
  <div class="secondary fs-lock">
    <v-row justify="center" class="text-center text-h6">
      PIN
    </v-row>
    <v-row id="pindots" justify="center">
      <div></div>
      <div :class="{ 'shake': shake }">
        <h-pin-dot
          v-for="i in pinLength"
          :key="`dot${i}`"
          :value="step"
          :threshold="i"
        />
      </div>
      <div>
        <v-btn
          icon
          :disabled="! pin.length"
          @click="del()"
        >
          <v-icon small v-text="backspace" />
        </v-btn>            
      </div>
    </v-row>
    <v-row justify="center">
      <h-pin-btn value="1" @click="add"/>
      <h-pin-btn value="2" @click="add"/>
      <h-pin-btn value="3" @click="add"/>
    </v-row>
    <v-row justify="center">
      <h-pin-btn value="4" @click="add"/>
      <h-pin-btn value="5" @click="add"/>
      <h-pin-btn value="6" @click="add"/>
    </v-row>
    <v-row justify="center">
      <h-pin-btn value="7" @click="add"/>
      <h-pin-btn value="8" @click="add"/>
      <h-pin-btn value="9" @click="add"/>
    </v-row>
    <v-row justify="center">
      <h-pin-btn value="0" @click="add"/>
    </v-row>
    <v-footer app color="secondary">
      <v-spacer />
      <h-version top />
    </v-footer>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Hashes from '@/Mixins/Hashes'
  import Lockable from '@/Mixins/Lockable'
  import UsesIcons from '@/Mixins/UsesIcons'
  import HVersion from '@/Components/Version'
  import HPinDot from './PinDot'
  import HPinBtn from './PinButton'

  export default {
    mixins: [
      Hashes,
      Lockable,
      UsesIcons,
    ],

    components: {
      HVersion,
      HPinDot,
      HPinBtn,
    },

    data: () => ({
      pin: '',
      step: 0,
      shake: false,
    }),

    computed: {
      backspace () {
        return this.pin.length
          ? this.icons.backspace
          : this.icons.backspaceOutline
      },
      ...mapGetters('rummage', [
        'waiters',
      ]),
      ...mapGetters('orders/config', [
        'pinLength',
      ]),
    },

    methods: {
      reset () {
        this.pin = ''
        this.step = 0
      },
      add (v) {
        if (this.locked) {
          return
        }
        this.lock()
        this.pin += v
        this.step++
        if (this.pin.length === this.pinLength) {
          this.check()
        }
      },
      del () {
        if (this.locked) {
          return
        }
        this.lock()
        this.pin = this.pin.slice(0, -1)
        this.step--
      },
      check () {
        const hash = this.hash(this.pin)
        const user = this.waiters.find(o => o.pin === hash)
        user ? this.unlock(user) : this.retry()
      },
      unlock (user) {
        setTimeout(() => {
          this.$store.dispatch('unlockScreen', user)
          this.reset()
        }, 50)
      },
      retry () {
        this.shake = true
        setTimeout(() => {
          this.shake = false
          this.reset()
        }, 475)
      },
    },
  }
</script>

<style lang="scss" scoped>
.fs-lock {
  position: absolute;
  width: 100vw;
  height: 100vh;
  z-index: 9998;
  padding-top: 56px;
}
.shake {
  animation: shake .45s;
}
@keyframes shake {
  15% { transform: translate(-8px, 0) }
  30% { transform: translate(8px, 0) }
  45% { transform: translate(-8px, 0) }
  60% { transform: translate(8px, 0) }
  75% { transform: translate(-8px, 0) }
  90% { transform: translate(8px, 0) }
}
#pindots {
  > div {
    width: 220px;
    height: 36px;
    text-align: center;
  }
  > div:first-child,
  > div:last-child {
    width: 36px;
  }
}
</style>
